import React, { useEffect, useState } from "react";

import { graphql, useStaticQuery } from "gatsby";
import { useIsSSR } from "react-aria";

import { gql } from "@apollo/client";
import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { useGraphqlLaravelLighthouse } from "../../../../providers/GraphqlLaravelLighthouse";
import { toReadableDate } from "../../../../utils/DateHelpers";
import Markdown, { MarkdownInline } from "../../Markdown";
import Headline from "../../NewHeadline";

const OuterContainer = styled.div`
    ${({ theme }) => css`
        ${theme.paddings.containerOuter.left}
        ${theme.paddings.containerOuter.right}
    `}
`;

const InnerContainer = styled.div`
    ${({ theme }) => css`
        ${theme.paddings.containerInner.left}
        ${theme.paddings.containerInner.right}
    `}
`;

const TextContainer = styled(Markdown)`
    color: ${({ theme }) => theme.colors.blue.toString()};
    ${({ theme }) => theme.breakpoints.from.small.css`
        column-count: 2;
        column-gap: 30px;
    `}
`;

const Date = styled.p`
    color: ${({ theme }) => theme.colors.blue.toString()};
`;

const dynamicQuery = gql`
    query {
        newTrend: helNewTrend(orderBy: { column: TREND_DATE, order: DESC }) {
            trend
            trend_date
            trend_text
        }
    }
`;

const HelNewTrend = ({ name, trend, container }) => {
    const component = (
        <div>
            {trend && (
                <>
                    <Headline>{name}</Headline>
                    <Date>{toReadableDate(trend.trend_date)}</Date>
                    <TextContainer>{trend.trend_text}</TextContainer>
                </>
            )}
        </div>
    );

    if (container === "no") {
        return component;
    }

    return (
        <OuterContainer>
            {container === "small" ? (
                <InnerContainer>{component}</InnerContainer>
            ) : (
                component
            )}
        </OuterContainer>
    );
};

const HelNewTrendContainer = ({ container, name }) => {
    const [freshTrend, setFreshTrend] = useState(undefined);
    const client = useGraphqlLaravelLighthouse();

    const isSSR = useIsSSR();

    const { laravelLighthouse } = useStaticQuery(graphql`
        query {
            laravelLighthouse {
                newTrend: helNewTrend(
                    orderBy: { column: TREND_DATE, order: DESC }
                ) {
                    trend
                    trend_date
                    trend_text
                }
            }
        }
    `);

    const loadNews = async () => {
        /**
         * We will compare the news from the static content to the news in our database.
         */
        if (!isSSR && client) {
            const data = await client.query({ query: dynamicQuery });
            if (data?.data?.newTrend) {
                setFreshTrend(data.data.newTrend);
            }
        }
    };

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        loadNews();
    }, [isSSR]);

    return (
        <HelNewTrend
            trend={freshTrend ?? laravelLighthouse.newTrend}
            container={container}
            name={name}
        />
    );
};

export default HelNewTrendContainer;
